import { Typography} from "@mui/material"
import Convention from "models/convention-api/v1/Convention"
import { useRouter } from "next/router"
import pluralize from "pluralize"
import { makeStyles } from "tss-react/mui-compat"

const useStyles = makeStyles()({
  headingText: {
    marginBottom: "15px",
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "16px",
    lineHeight: "22px",
  },
});

interface IEventHeaderPage {
  headingName: string
  headerText: string
  resultsCount: number
}

const EventHeaderPage = (props: IEventHeaderPage) => {
  const { classes } = useStyles()
  const { query } = useRouter()
  const { data: convention } = Convention.useLoadOne(query.convention_id as string)

  return (
    <>
      <h1>{props.headingName}</h1>
      {convention && (
        <Typography variant="h5" className={classes.headingText}>
          There are currently {pluralize(props.headerText, props.resultsCount, true)} in{" "}
          {convention.name}
        </Typography>
      )}
    </>
  )
}

export default EventHeaderPage
